import { SCREEN_WIDTH_MOBILE, SCREEN_WIDTH_TABLET } from 'config';

export const isMobile = () => window.innerWidth < SCREEN_WIDTH_MOBILE;
export const isTablet = () => window.innerWidth < SCREEN_WIDTH_TABLET;
